module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Strettoia_Simmetrica-BN-CL.1c230ecd.svg";